import { COMPOSER_MOBILE_ROW_HEIGHT_PX, COMPOSER_ROW_HEIGHT_PX } from "./composerConstants";

/** Altura de uma linha do textarea (sem contar adornments). */
export const COMPOSER_TEXTAREA_LINE_HEIGHT_PX = 24;

const scrollbarSx = {
  "&::-webkit-scrollbar": { width: "5px" },
  "&::-webkit-scrollbar-thumb": { backgroundColor: "#b0b0b0", borderRadius: "10px" },
  "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#888888" },
  "&::-webkit-scrollbar-track": { backgroundColor: "#f1f1f1" },
};

/**
 * Estilos do TextField multiline do composer.
 * Trava a altura quando vazio (:placeholder-shown) para placeholder longo não expandir o input.
 */
export const COMPOSER_TEXT_FIELD_SX = {
  flex: 1,
  minWidth: 0,
  "& .MuiInputBase-root": {
    minHeight: `${COMPOSER_ROW_HEIGHT_PX}px`,
    boxSizing: "border-box",
    borderRadius: "0 !important",
    overflow: "hidden",
    clipPath: "none",
    alignItems: "center",
    ...scrollbarSx,
    "&:has(textarea:placeholder-shown)": {
      maxHeight: `${COMPOSER_ROW_HEIGHT_PX}px`,
      alignItems: "center",
    },
  },
  "& .MuiInputAdornment-root": {
    alignSelf: "center",
    height: "auto",
    maxHeight: "none",
    marginTop: "0 !important",
    marginBottom: "0 !important",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "0 !important",
    overflow: "hidden",
    clipPath: "none",
    "& fieldset": { border: "none" },
    "&:hover fieldset": { border: "none" },
    "&.Mui-focused fieldset": { border: "none" },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none !important",
    borderRadius: "0 !important",
  },
  "& textarea, & .MuiInputBase-inputMultiline": {
    overflowY: "auto",
    resize: "none",
    boxSizing: "border-box",
    borderRadius: "inherit",
    overflowX: "hidden",
    padding: "4px 10px",
    lineHeight: `${COMPOSER_TEXTAREA_LINE_HEIGHT_PX}px`,
    ...scrollbarSx,
    "&:placeholder-shown": {
      height: `${COMPOSER_TEXTAREA_LINE_HEIGHT_PX}px !important`,
      minHeight: `${COMPOSER_TEXTAREA_LINE_HEIGHT_PX}px !important`,
      maxHeight: `${COMPOSER_TEXTAREA_LINE_HEIGHT_PX}px !important`,
      overflow: "hidden !important",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      lineHeight: `${COMPOSER_TEXTAREA_LINE_HEIGHT_PX}px !important`,
    },
  },
};

/** TextField do composer no mobile: 16px evita zoom do iOS e o placeholder pode quebrar em 2 linhas. */
export const COMPOSER_MOBILE_TEXT_FIELD_SX = {
  ...COMPOSER_TEXT_FIELD_SX,
  "& .MuiInputBase-root": {
    ...COMPOSER_TEXT_FIELD_SX["& .MuiInputBase-root"],
    minHeight: `${COMPOSER_MOBILE_ROW_HEIGHT_PX}px`,
    "&:has(textarea:placeholder-shown)": {
      maxHeight: "none",
      minHeight: `${COMPOSER_MOBILE_ROW_HEIGHT_PX}px`,
      alignItems: "center",
    },
  },
  "& textarea, & .MuiInputBase-inputMultiline": {
    ...COMPOSER_TEXT_FIELD_SX["& textarea, & .MuiInputBase-inputMultiline"],
    fontSize: "16px",
    WebkitTextSizeAdjust: "100%",
    padding: "8px 8px",
    "&:placeholder-shown": {
      height: "auto !important",
      minHeight: `${COMPOSER_TEXTAREA_LINE_HEIGHT_PX}px !important`,
      maxHeight: `${COMPOSER_TEXTAREA_LINE_HEIGHT_PX * 2}px !important`,
      overflow: "visible !important",
      whiteSpace: "pre-wrap",
      textOverflow: "unset",
      overflowWrap: "break-word",
      wordBreak: "normal",
      lineHeight: `${COMPOSER_TEXTAREA_LINE_HEIGHT_PX}px !important`,
    },
  },
};
